import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CommonProvider } from '../common';
import { Response } from '../response';

/*
  Generated class for the CompanyProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class CompanyProvider {

  private _url: string = 'api/v1/company';
  
  constructor(public http: HttpClient, private commonProvider: CommonProvider) {}

  getAll(): Observable<Response<Company[]>> {
    return this.http.get<Response<Company[]>>(this.commonProvider.apiUrl + this._url + '/list');
  }

  get(id: string): Observable<Response<Company>> {
    return this.http.get<Response<Company>>(this.commonProvider.apiUrl + this._url + `/${id}/show`);
  }

}

export interface Company {
  id: string;
  code: string;
  owner_id: string;
  created_at: string;
  updated_at: string;
  deleted_at?: string;
}


// WEBPACK FOOTER //
// ./src/providers/company/company.ts